module.exports = __webpack_public_path__ + "img/IMG_9674-5.19a8f4b7.png";